import {
  ComponentConfig,
  LayoutTypes,
  ComponentType,
  FlexDirection,
  InputType,
  ValidationRule,
} from "../services/types/ComponentTypes";

export const screen_140_add_purchase_with_order: ComponentConfig[] = [
  {
    componentType: LayoutTypes.SCREEN_GROUP,
    title: "Purchase with order",
    style: {},
    childComponents: [
      {
        componentType: LayoutTypes.FORM,
        Name: "pur_add",
        TableName: "purchase",
        columnNumber: "m1 t1 w1",
        style: {
          padding: 10,
          backgroundColor: "#ffffff",
          direction: FlexDirection.COLUMN,
        },
        Fields: [
          {
            componentType: LayoutTypes.FIELD_GROUP,
            Label: "Purchase details",
            BindValue: "con_purchase_details",
            style: {
              direction: FlexDirection.COLUMN,
            },
            childComponents: [
              {
                componentType: ComponentType.SEARCHABLE_DROPDOWN,
                name: "drp_purchase",
                label: "Purchase order No.",
                placeholder: "",
                required: false,
                lookupName: "purchare_order",
                options: [],
                searchable: true,
                clearable: true,
                Json_Attribute: "purchase_order_id",
                BindValue: "drp_purchase",
              },
              {
                componentType: ComponentType.TEXT_FIELD,
                name: "txt_purchaseno",
                label: "Purchase No.",
                placeholder: "Will be auto generated...",
                required: false,
                inputType: InputType.TEXT,
                disabled: true,
                Json_Attribute: "purchase_no",
                AutoPopulate: true,
                AutoPopulate_format: "PUR_[******]",
              },
              {
                componentType: ComponentType.DATE_FIELD,
                name: "txt_Purchase_date",
                label: "Purchase date",
                placeholder: "",
                required: true,
                Json_Attribute: "purchase_date",
                DefaultToday: true,
                validation: [
                  {
                    rule: ValidationRule.REQUIRED,
                    message: "Purchase date is required",
                  },
                ],
              },
              {
                componentType: ComponentType.TEXT_FIELD,
                name: "txt_mobile",
                label: "Mobile",
                placeholder: "",
                required: false,
                inputType: InputType.PHONE,
                disabled: false,
                Json_Attribute: "mobile_no",
                BindParent: {
                  drp_purchase: "mobile_no",
                },
              },
              {
                componentType: ComponentType.TEXT_FIELD,
                name: "txt_trn",
                label: "TRN.",
                placeholder: "",
                required: false,
                inputType: InputType.TEXT,
                disabled: true,
                Json_Attribute: "vendor_taxregno",
                BindParent: {
                  drp_purchase: "taxregno",
                },
              },
              {
                componentType: ComponentType.TEXT_FIELD,
                name: "sup_name",
                label: "Vendor name",
                placeholder: "",
                required: false,
                inputType: InputType.TEXT,
                disabled: true,
                Json_Attribute: "",
                BindParent: {
                  drp_purchase: "sname",
                },
              },
              {
                componentType: ComponentType.CHECKBOX,
                name: "is_cash",
                label: "Cash purchase",
                placeholder: "",
                required: false,
                inputType: InputType.TEXT,
                Json_Attribute: "is_cash",
                defaultValue: "False",
              },
              {
                componentType: ComponentType.TEXT_FIELD,
                name: "txt_vendor_refno",
                label: "Vendor Ref No.",
                placeholder: "",
                required: false,
                inputType: InputType.TEXT,
                Json_Attribute: "vendor_refno",
              },
              {
                componentType: ComponentType.DATE_FIELD,
                name: "txt_Purchase_ref_date",
                label: "Ref date",
                placeholder: "",
                DefaultToday: true,
                required: false,
                Json_Attribute: "ref_date",
              },
              {
                componentType: ComponentType.TEXT_FIELD,
                name: "txt_billingaddress",
                label: "Address",
                placeholder: "",
                required: false,
                inputType: InputType.TEXT,
                disabled: true,
                Json_Attribute: "billing_address",
                BindParent: {
                  drp_purchase: "billing_address",
                },
              },
              {
                componentType: ComponentType.TEXT_FIELD,
                name: "txt_remarks",
                label: "Remarks",
                placeholder: "",
                required: false,
                inputType: InputType.TEXT,
                Json_Attribute: "remarks",
              },
              {
                componentType: ComponentType.TEXT_FIELD,
                name: "txt_round_off",
                label: "Round off",
                placeholder: "",
                required: true,
                inputType: InputType.NUMBER,
                Json_Attribute: "round_off_amt",
              },
              {
                componentType: ComponentType.DATE_FIELD,
                name: "txt_due_date",
                label: "Due date",
                placeholder: "",
                required: true,
                Json_Attribute: "due_date",
                DefaultToday: true,
              },
            ],
          },
          {
            componentType: ComponentType.SUB_MODULE,
            name: "purchase_details",
            label: "Purchase details",
            tableName: "purchase_details",
            lookupName: "purchase_order_details",
            parentField: "drp_purchase",
            BindValue: "jobcard_details",
            enableAddAction: false, // Disable manual add - data comes from purchase order
            childControls: [
              {
                componentType: ComponentType.SEARCHABLE_DROPDOWN,
                name: "job_card_id_item",
                label: "Jobcard No.",
                placeholder: "",
                required: false,
                lookupName: "parts_issue_jobcard_purchase",
                options: [],
                searchable: true,
                clearable: true,
                Json_Attribute: "job_card_id",
                BindValue: "job_card_id_item",
              },
              {
                componentType: ComponentType.SEARCHABLE_DROPDOWN,
                name: "drp_product",
                label: "Code",
                placeholder: "",
                required: false,
                lookupName: "product_itemcode",
                options: [],
                searchable: true,
                clearable: true,
                Json_Attribute: "product_id",
                BindValue: "drp_product",
              },
              {
                componentType: ComponentType.TEXT_FIELD,
                name: "txt_itemname",
                label: "Item name",
                placeholder: "",
                required: false,
                inputType: InputType.TEXT,
                Json_Attribute: "item_name",
                disabled: true,
                BindValue: "txt_itemname",
                BindParent: {
                  drp_product: "item_name",
                },
              },
              {
                componentType: ComponentType.TEXT_FIELD,
                name: "txt_rate",
                label: "Rate",
                placeholder: "",
                required: false,
                inputType: InputType.NUMBER,
                defaultValue: "0",
                Json_Attribute: "rate",
                disabled: true,
                BindValue: "txt_rate",
                ExpressionV2: "[drp_product.purchase_rate]",
              },
              {
                componentType: ComponentType.TEXT_FIELD,
                name: "txt_qty",
                label: "Qty",
                placeholder: "",
                required: false,
                inputType: InputType.NUMBER,
                defaultValue: "0",
                Json_Attribute: "qty",
                disabled: true,
                BindValue: "txt_qty",
                validation: [
                  {
                    rule: ValidationRule.CUSTOM,
                    message: "The quantity should be greater than 0",
                    condition: "[txt_qty] > 0",
                  },
                ],
              },
              {
                componentType: ComponentType.TEXT_FIELD,
                name: "txt_amount",
                label: "Amount",
                placeholder: "",
                required: false,
                inputType: InputType.NUMBER,
                defaultValue: "0",
                Json_Attribute: "amount",
                disabled: true,
                BindValue: "txt_amount",
                ExpressionV2: "[txt_rate] * [txt_qty]",
              },
              {
                componentType: ComponentType.SELECT_DROPDOWN,
                name: "drp_vat",
                label: "VAT%",
                placeholder: "",
                required: false,
                lookupName: "tax_rates",
                options: [],
                defaultValue: "5%",
                Json_Attribute: "vat_id",
                BindValue: "drp_vat",
              },
              {
                componentType: ComponentType.TEXT_FIELD,
                name: "txt_vat_amt",
                label: "VAT amount",
                placeholder: "",
                required: false,
                inputType: InputType.NUMBER,
                defaultValue: "0",
                Json_Attribute: "vat_amt",
                disabled: true,
                BindValue: "txt_vat_amt",
                ExpressionV2: "[txt_amount] * ([drp_vat.taxrate]/100)",
              },
              {
                componentType: ComponentType.TEXT_FIELD,
                name: "txt_discount",
                label: "Discount",
                placeholder: "",
                required: false,
                inputType: InputType.NUMBER,
                defaultValue: "0",
                Json_Attribute: "discount",
                BindValue: "txt_discount",
              },
              {
                componentType: ComponentType.TEXT_FIELD,
                name: "txt_net_amt",
                label: "Net amount",
                placeholder: "",
                required: false,
                inputType: InputType.NUMBER,
                defaultValue: "0",
                Json_Attribute: "net_amt",
                disabled: true,
                BindValue: "txt_net_amt",
                ExpressionV2: "[txt_amount] + [txt_vat_amt] - [txt_discount]",
              },
            ],
            FooterControls: [
              {
                componentType: ComponentType.TEXT_FIELD,
                BindValue: "txt_one",
                IncludeLabel: false,
                IsReadOnly: true,
                style: { display: "none" },
              },
              {
                componentType: ComponentType.TEXT_FIELD,
                BindValue: "txt_2",
                IncludeLabel: false,
                IsReadOnly: true,
                style: { display: "none" },
              },
              {
                componentType: ComponentType.TEXT_FIELD,
                BindValue: "txt_3",
                IncludeLabel: false,
                IsReadOnly: true,
                style: { display: "none" },
              },
              {
                componentType: ComponentType.TEXT_FIELD,
                BindValue: "txt_4",
                IncludeLabel: false,
                IsReadOnly: true,
                style: { display: "none" },
              },
              {
                componentType: ComponentType.TEXT_FIELD,
                BindValue: "txt_6",
                IncludeLabel: false,
                IsReadOnly: true,
                style: { display: "none" },
              },
              {
                IncludeLabel: false,
                Label: "Amount",
                PlaceHolder: "",
                IsMandatory: false,
                BindValue: "txt_sub_amount",
                Json_Attribute: "amount",
                componentType: ComponentType.TEXT_FIELD,
                showInSummary: false,
                IsReadOnly: true,
                ExpressionV2: "[SUM:txt_amount]",
                IsVerticalView: true,
                inputType: InputType.NUMBER,
                Default_Value: "0",
              },
              {
                componentType: ComponentType.TEXT_FIELD,
                BindValue: "txt_7",
                IncludeLabel: false,
                IsReadOnly: true,
                style: { display: "none" },
              },
              {
                IncludeLabel: false,
                Label: "VAT amount",
                PlaceHolder: "",
                IsMandatory: false,
                BindValue: "spare_vat_amount",
                Json_Attribute: "vat_amount",
                componentType: ComponentType.TEXT_FIELD,
                showInSummary: false,
                IsReadOnly: true,
                ExpressionV2: "[SUM:txt_vat_amt]",
                IsVerticalView: true,
                inputType: InputType.NUMBER,
                Default_Value: "0",
              },
              {
                IncludeLabel: false,
                Label: "Net discount",
                PlaceHolder: "",
                IsMandatory: false,
                BindValue: "txt_net_discount",
                Json_Attribute: "net_discount",
                componentType: ComponentType.TEXT_FIELD,
                showInSummary: false,
                IsReadOnly: true,
                ExpressionV2: "[SUM:txt_discount]",
                IsVerticalView: true,
                inputType: InputType.NUMBER,
                Default_Value: "0",
              },
              {
                IncludeLabel: false,
                Label: "Net amount",
                PlaceHolder: "",
                IsMandatory: false,
                BindValue: "txt_sub_net_amount",
                Json_Attribute: "net_amount",
                componentType: ComponentType.TEXT_FIELD,
                showInSummary: false,
                IsReadOnly: true,
                ExpressionV2: "[SUM:txt_net_amt]",
                IsVerticalView: true,
                inputType: InputType.NUMBER,
                Default_Value: "0",
              },
            ],
          },
        ],
      },
      {
        componentType: ComponentType.BUTTON,
        name: "Submit",
        onPressAction: "save",
        style: {
          backgroundColor: "#22c55e",
        },
      },
    ],
  },
];

